<template>
  <div class="about">
    <v-img
      alt="LogoCnr"
      class="shrink mr-2"
      contain
      src="@/assets/logo-isc-transparent.png"
      transition="scale-transition"
      width="300"
    />
    <v-alert type="warning" outlined>Sito demo NON operativo</v-alert>
    <a target="_blank" :href="'mailto:' + email + '?subject=nv1500.web.app'">{{
      email
    }}</a>
    <v-alert type="info" outlined>Versione App {{ versione }}</v-alert>
    <router-link to="/Privacy">Privacy</router-link>
  </div>
</template>
<script>
export default {
  name: "About",
  data: () => ({
    // email: "&#102;r&#97;&#110;cis&#46;f&#97;&#114;relly&#64;isc.&#99;&#110;r.it"
    email: "francis.farrelly@isc.cnr.it",
  }),
  computed: {
    versione() {
      return process.env.VUE_APP_PACKAGE_VERSION;
    },
  },
};
</script>
